import React, {useState, useEffect, useContext} from 'react';
import { useParams } from "react-router-dom";
import {properties as appProperties} from '../../../AppData';
import AndaluciaSeguraStyle from './AndaluciaSeguraStyle';
import RestProvider from 'providers/RestProvider';
import {properties} from './AndaluciaSeguraData';
import { CircularProgress, Backdrop } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AppContext from 'AppContext';
import { getContextFromUrl} from 'config/Config';

function AndaluciaSeguraCard() {

  //HOOKS
  const [isLoading, setIsLoading] = useState(false);
  const [isPhoneVersion, setIsPhoneVersion] = useState(false);
  const [andaluciaSegura, setAndaluciaSegura] = useState([]);
  const {idExpediente} = useParams();
  const context = useContext(AppContext);
  const {crudOperation, crudOperationsType} = RestProvider();


  //LLAMADAS
  useEffect(() => {
    updateFormat();
    getDataAndaluciaSegura();
    return () => window.removeEventListener('resize', updateFormat);
  }, []) ;
      
  /**Llamada al microservicio de moad-api-proxy para recuperar los datos de andalucia segura */
  const getDataAndaluciaSegura = async () => {
    setIsLoading(true);
    crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url: properties.URL + idExpediente, method: 'get'}).then(response => {
        setAndaluciaSegura(response.data); 
        let tmp = response.data;
        context.updateTitlePage(
          tmp.estado == 'ANUL' || tmp.estado == null ?
            properties.TITULO_NO_EXISTE :
            properties.TITULO_EXISTE + tmp.denominacionComercial + "'"
        );
    }).catch(function (error) {
      setIsLoading(false);      
    }).finally(function () {
      setIsLoading(false);
    })
  }

  /**Método que capta el tamaño de la ventana y actualiza actualiza
    ***el hook que controla cuando se da el salto a versión movil*/
   const updateFormat = () => {

    if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
        setIsPhoneVersion(true);
    } else {
        setIsPhoneVersion(false);
    }
  };

  window.addEventListener('resize', updateFormat);

  //RENDER
  return (
    <div className={AndaluciaSeguraStyle().root}>
      <h2 id="tituloPagina" className={AndaluciaSeguraStyle().classEncabezado}>
        {andaluciaSegura.estado == 'ANUL' || andaluciaSegura.estado == null ?
          properties.TITULO_NO_EXISTE :
          properties.TITULO_EXISTE + andaluciaSegura.denominacionComercial + "'"
        }
      </h2>


    <Card className={AndaluciaSeguraStyle().cardAndSegura}>
      <CardHeader
        title={
            <Typography>
                <h3 className={AndaluciaSeguraStyle().classEncabezadoH3} style={{marginLeft: '0px'}}>
                  Datos Generales
                </h3>                
            </Typography>
        }
        subheader={
          andaluciaSegura.estado == 'ANUL' || andaluciaSegura.estado == null ?
            <Typography style={{ display: 'inline-block' }}>
              <Box fontWeight="fontWeightBold" fontSize={15} color="black" mr={1}>
              </Box>
            </Typography>
          :
            <><Box><Typography style={{ display: 'inline-block' }}>
                <Box fontWeight="fontWeightBold" fontSize={15} color="black" mr={1}>
                    Nombre / Denominación Comercial:
                </Box>
            </Typography>
                <Typography style={{ display: 'inline-block' }}>
                    <Box fontWeight="fontWeightLight" fontSize={14} color="black">
                    {andaluciaSegura.denominacionComercial}
                    </Box>
                </Typography>
                </Box><Box>
                <Typography style={{ display: 'inline-block' }}>
                    <Box fontWeight="fontWeightBold" fontSize={15} color="black" mr={1}>
                        CIF/NIF/NIE:
                    </Box>
                </Typography>
                    <Typography style={{ display: 'inline-block' }}>
                        <Box fontWeight="fontWeightLight" fontSize={14} color="black">
                        {andaluciaSegura.documentacion}
                        </Box>
                    </Typography></Box>
                <Box>
                <Typography style={{ display: 'inline-block' }}>
                    <Box fontWeight="fontWeightBold" fontSize={15} color="black" mr={1}>
                        Dirección:
                    </Box>
                </Typography>
                    <Typography style={{ display: 'inline-block' }}>
                        <Box fontWeight="fontWeightLight" fontSize={14} color="black">
                        {andaluciaSegura.direccion}
                        </Box>
                    </Typography></Box>
                    <Typography>                                  
            </Typography></>
        }
      />
      <hr className={AndaluciaSeguraStyle().classLine} />
      <h3 className={AndaluciaSeguraStyle().classEncabezadoH3}>
        Estado
      </h3>  
      <CardMedia
        className={isPhoneVersion ? AndaluciaSeguraStyle().mediaMovil : AndaluciaSeguraStyle().media}
        image={andaluciaSegura.estado == 'VALI' ? 
        `${getContextFromUrl()}andaluciaSegura/andSegura.jpg` :
        `${getContextFromUrl()}andaluciaSegura/nocheck.png`}
        title="Andalucía Segura"
      />
      <hr className={AndaluciaSeguraStyle().classLine} />
      <h3 className={AndaluciaSeguraStyle().classEncabezadoH3}>
        Andalucía Segura
      </h3>
      <CardContent>
        <Typography component="p" style={{ display: 'inline-block' }}>
        <Box fontWeight="fontWeightLight" fontSize={15} color="black" mr={1}>
          {
            andaluciaSegura.estado == 'VALI' ?
              "Este establecimiento ha obtenido el sello" :
            andaluciaSegura.estado == 'NOVA' || andaluciaSegura.estado == 'CADU' || andaluciaSegura.estado == 'DESI' ?
              "Este establecimiento" :
              ""
          }
        </Box>
        </Typography>
        <Typography component="p" style={{ display: 'inline-block' }}>
        <Box fontWeight="fontWeightBold" fontSize={16} color="black">
          {andaluciaSegura.estado == 'NOVA' || andaluciaSegura.estado == 'CADU' || andaluciaSegura.estado == 'DESI' ?
            'NO cuenta con el sello "Andalucía Segura"' :
            andaluciaSegura.estado != 'ANUL' && andaluciaSegura.estado != null ?
              '"Andalucía Segura"':
              ""
            }
        </Box>
        </Typography>
        <Typography component="p">
        <Box fontWeight="fontWeightLight" fontSize={15} color="black">
        {
          andaluciaSegura.estado == 'VALI' ?
            "Declaración presentada correctamente el " + new Date(andaluciaSegura.fechaIniValidez).toLocaleDateString() + " (validez 1 año)" :
            ""
        }
        </Box>
        </Typography>
      </CardContent>
    </Card>
    <Backdrop className={AndaluciaSeguraStyle().classBackdrop} open={isLoading}>
      <CircularProgress color="inherit" />
    </Backdrop>
    </div>
  )
}
export default AndaluciaSeguraCard